export const faqItems = [
  {
    question: '这些免费看片平台真的完全免费吗？',
    answer: '是的，本文推荐的所有平台均提供真正的免费观影服务。部分平台采用"免费+广告"模式，通过广告收入支撑免费内容；部分平台如CCTV节目官网为公共服务性质，完全免费且无广告。少数平台采用"限免"模式，定期推出免费观影活动，用户可以关注限免时段观看。',
  },
  {
    question: '免费平台的画质怎么样？能看高清吗？',
    answer: '本文推荐的平台均支持高清画质播放，大部分平台支持1080P全高清，腾讯视频等头部平台甚至支持4K超清画质。正版平台的视频源质量有保障，画面清晰、音质优良，远优于盗版网站的模糊画质。但免费用户可能在画质选择上有所限制，最高画质通常需要会员。',
  },
  {
    question: '免费平台安全吗？会不会有病毒？',
    answer: '本文推荐的平台均为正规运营的正版平台，已通过安全验证，不会有病毒或恶意软件。正版平台使用标准的网页播放技术，无需下载额外软件。建议认准官方域名和APP，避免访问仿冒网站。如果您不确定某个平台是否安全，可以参考本文的安全指南进行验证。',
  },
  {
    question: '需要注册账号才能观看吗？',
    answer: '大部分平台无需注册即可观看，如1905电影网、CCTV节目官网、爱奇艺免费专区等。部分平台可能需要简单注册（通常只需手机号）才能使用弹幕、收藏等互动功能，但观看视频本身通常不需要登录。',
  },
  {
    question: '免费平台的内容更新速度快吗？',
    answer: '更新速度因平台和内容类型而异。B站、爱奇艺等平台的日漫新番基本与日本同步更新；西瓜视频、腾讯视频的国产剧更新也非常及时，通常在电视台播出后数小时内上线。纪录片和经典电影属于长线内容，更新频率相对较低。整体来说，正版免费平台的更新速度令人满意。',
  },
  {
    question: '可以在手机上观看吗？',
    answer: '可以。本文推荐的所有平台均有对应的手机APP，支持iOS和Android系统，部分平台还支持小程序和H5网页直接观看。手机端观看体验良好，支持投屏到电视、画质切换、离线缓存等功能（部分功能可能需要会员）。',
  },
  {
    question: '免费平台会有很多广告吗？',
    answer: '不同平台的广告策略不同。B站影视区完全没有贴片广告；CCTV节目官网同样无广告；其余平台通常在视频播放前有15-30秒的贴片广告，这是平台的主要收入来源，属于合理范围。与盗版网站泛滥的低质量恶意广告相比，正版平台的广告体验要好得多。',
  },
  {
    question: '海外用户可以观看这些平台吗？',
    answer: '部分平台在海外可能存在区域限制。B站、爱奇艺等平台的国际版（如BiliBili International、iQIYI International）面向海外用户提供服务。建议海外用户使用平台对应的国际版APP，或通过合法VPN服务访问。具体可查看各平台的海外服务政策。',
  },
];

export const aboutFeatures = [
  {
    title: '正版合规',
    description: '我们推荐的每一个平台均经过严格筛选，确保内容来源合法合规，支持正版影视产业发展。',
    icon: 'ri-shield-check-line',
  },
  {
    title: '免费导向',
    description: '专注于发现和评测真正免费的观影渠道，让每个人都能无负担享受优质影视内容。',
    icon: 'ri-money-cny-circle-line',
  },
  {
    title: '客观评测',
    description: '从画质、片库、体验、安全等多维度进行客观评测，为用户提供真实可靠的平台选择参考。',
    icon: 'ri-scales-line',
  },
  {
    title: '持续更新',
    description: '团队持续跟踪各大平台动态，及时更新推荐内容，确保信息的时效性和准确性。',
    icon: 'ri-refresh-line',
  },
];

export const aboutStats = [
  { value: '10+', label: '评测平台' },
  { value: '50+', label: '原创文章' },
  { value: '100万+', label: '累计读者' },
  { value: '99.8%', label: '好评率' },
];